export default class Blockbrief {
  defaultConfig = (packageKey, productId) => {
    return {
      configuration: {
        package: packageKey,
        number_of_users: packageKey === 'premier' ? 1 : 4,
        product_id: productId
      }
    };
  };
}
